import { useCallback } from 'react';

import { useLocation } from 'react-router';

import { useTracking } from '@change-corgi/core-react/tracking';

type UseMediaReturn = ModelHookResult<{ descriptionLinkHref: string }, { descriptionLinkOnClick: () => void }>;

export function useMedia(): UseMediaReturn {
	const track = useTracking();
	const location = useLocation();
	const descriptionLinkHref = `${location.pathname}${location.search}#media-tips`;

	const descriptionLinkOnClick = useCallback(() => {
		void track('sap_media_tips_link_click');
	}, [track]);

	return { data: { descriptionLinkHref }, actions: { descriptionLinkOnClick } };
}
